import React, { useEffect, useState } from "react";
import { Button, Form, Spin, Modal, Popconfirm } from "antd";
import { useDispatch, useSelector } from "react-redux";

import { PAGE_SIZE } from "../../constants";
import { Link } from "react-router-dom";
import {
	createMaintenance,
	deleteMaintenance,
	fetchMaintenances,
	updateMaintenance,
} from "../../actions/maintenance";
import { ReactSVG } from "react-svg";
import MaintenancesTable from "../Tables/Maintenances";
import MaintenanceForm from "../Forms/Maintenance";
import moment from "moment";

const MaintenancesPage = () => {
	const [form] = Form.useForm();
	const dispatch = useDispatch();
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [maintenanceId, setMaintenanceId] = useState(null);
	const { maintenances, status, loading } = useSelector(
		(state) => state.fetchMaintenances,
	);
	const { status: updateStatus } = useSelector(
		(state) => state.updateMaintenance,
	);
	const { maintenanceDeleted } = useSelector(
		(state) => state.deleteMaintenance,
	);

	const showModal = () => {
		setIsModalVisible(true);
	};

	const handleOk = () => {
		setIsModalVisible(false);
	};

	const handleCancel = () => {
		setIsModalVisible(false);
	};

	const handleClickDelete = (record) => {
		dispatch(deleteMaintenance(record.id));
	};

	const handleAddMaintenance = () => {
		showModal();
		setMaintenanceId("");
		form.resetFields();
	};

	const handleEdit = (record) => {
		showModal();
		setMaintenanceId(record.id);
		form.setFieldsValue({
			...record,
			periodFrom: moment(record.periodFrom).utcOffset("+08:00"),
			periodTo: moment(record.periodTo).utcOffset("+08:00"),
		});
	};

	const handleSubmitForm = (values) => {
		if (maintenanceId) {
			dispatch(updateMaintenance(maintenanceId, values));
		} else {
			dispatch(createMaintenance(values));
		}
		handleOk();
	};

	const withAction = (record) => {
		return (
			<span className="action" style={{ display: "flex" }}>
				<Link to={`/maintenances/${record.id}`}>
					<Button type="link" className="btn-table-action-primary">
						Show
					</Button>
				</Link>
				<Button
					type="link"
					className="btn-table-action-primary"
					onClick={() => handleEdit(record)}
				>
					Edit
				</Button>
				<Popconfirm
					title="Are you sure to delete this one?"
					onConfirm={() => handleClickDelete(record)}
					okText="Yes"
					cancelText="No"
				>
					<Button type="link" className="btn-table-action-danger">
						Delete
					</Button>
				</Popconfirm>
			</span>
		);
	};

	useEffect(() => {
		if (status === "IDLE")
			dispatch(fetchMaintenances({ start: 0, count: PAGE_SIZE }));
	}, [status]);

	useEffect(() => {
		if (updateStatus === "SUCCEEDED")
			dispatch(fetchMaintenances({ start: 0, count: PAGE_SIZE }));
	}, [updateStatus]);

	useEffect(() => {
		if (maintenanceDeleted) {
			dispatch(fetchMaintenances({ start: 0, count: PAGE_SIZE }));
		}
	}, [maintenanceDeleted]);

	return (
		<div className="maintenances-container">
			<div className="page-header">
				<div className="page-header-breadbrumb">
					<ul>
						<li>Maintenances</li>
					</ul>
				</div>
				<div className="page-header-actions">
					<Button
						type="primary"
						className="btn btn-primary"
						onClick={handleAddMaintenance}
					>
						New Maintenance
						<ReactSVG src="/icons/post-add.svg" />
					</Button>
				</div>
			</div>
			<div className="page-content">
				{status === "SUCCEEDED" && (
					<Spin spinning={loading}>
						<MaintenancesTable
							rowKey="id"
							pagination={false}
							dataSource={maintenances.data}
							scrollHeight="calc(100vh - 275px)"
							actionWidth={150}
							withAction={withAction}
						/>
					</Spin>
				)}
			</div>
			<Modal
				className="topic-modal"
				visible={isModalVisible}
				onOk={handleOk}
				onCancel={handleCancel}
				footer={null}
			>
				<MaintenanceForm
					form={form}
					maintenanceId={maintenanceId}
					handleSubmitForm={handleSubmitForm}
					handleCancel={handleCancel}
				/>
			</Modal>
		</div>
	);
};

export default MaintenancesPage;
